var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn",class:( _obj = {}, _obj[("btn-" + _vm.type)] = true, _obj['btn-block'] =  _vm.block, _obj['btn-lg'] =  _vm.large, _obj['btn-loading'] =  _vm.loading, _obj ),attrs:{"type":_vm.nativeType,"disabled":_vm.loading}},[_vm._t("default"),_vm._v(" "),(!_vm.loading)?_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.ico),expression:"ico"}],class:_vm.ico,attrs:{"aria-hidden":"true"}}):_c('i',{staticClass:"fa fa-spinner fa-pulse fa-fw"})],2)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17f165da","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/basicos/Button.vue
// module id = Eq0d
// module chunks = 49